import { render, staticRenderFns } from "./modal-add-treatment.vue?vue&type=template&id=6cd9584f&scoped=true&lang=pug"
import script from "./modal-add-treatment.js?vue&type=script&lang=js&external"
export * from "./modal-add-treatment.js?vue&type=script&lang=js&external"
import style0 from "./modal-add-treatment.vue?vue&type=style&index=0&id=6cd9584f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd9584f",
  null
  
)

export default component.exports